import { render, staticRenderFns } from "./Followup.vue?vue&type=template&id=6f52f416"
import script from "./Followup.vue?vue&type=script&lang=js"
export * from "./Followup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports